import * as React from "react"
import Svg, { Rect, Circle, Path, Defs, Pattern, Use } from "react-native-svg"

const FakeVideosContent = (props) => {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={335}
            height={208}
            fill="none"
            viewBox="0 0 335 208"
            {...props}
        >
            <Rect width={335} height={208} fill="url(#pattern0)" rx={10} />
            <Circle cx={167} cy={104} r={29} fill="#fff" />
            <Path
                fill="#3EABAB"
                d="M167 75c-16.016 0-29 12.984-29 29s12.984 29 29 29 29-12.984 29-29-12.984-29-29-29zm10.023 30.537l-14.5 9.063a1.814 1.814 0 01-2.773-1.538V94.938a1.812 1.812 0 012.773-1.538l14.5 9.063a1.813 1.813 0 010 3.074z"
            />
            <Defs>
                <Pattern id="pattern0" width={1} height={1} patternContentUnits="objectBoundingBox">
                    <Use transform="matrix(.00067 0 0 .00107 0 -.037)" xlinkHref="#image0" />
                </Pattern>
            </Defs>
        </Svg>
    )
}

export default FakeVideosContent
